import { object, string } from 'yup'

// Mirrors the backend limit (AIInstructionWriteDTO).
export const MAX_AI_INSTRUCTION_LENGTH = 4000

export const aiInstructionSchema = object({
  text: string()
    .trim()
    .required('Bitte eine Instruktion eingeben')
    .max(MAX_AI_INSTRUCTION_LENGTH, `Maximal ${MAX_AI_INSTRUCTION_LENGTH} Zeichen`),
})

export interface AIInstructionFormValues {
  text: string
}
